import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { UserGroupWithMembers } from '../types/userGroup';
import customFetch from '../utils/fetch';
export const useGetUserGroups = () => {
  const {
    data,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['getUserGroups'],
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/user/group`, {});
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch user groups');
      }
      const {
        data,
        success,
        error
      } = (await response.json() as {
        data: UserGroupWithMembers;
        error: string;
        success: boolean;
      });
      if (!success) {
        throw new Error(error);
      }
      return {
        groups: data.groups,
        users: data.users
      };
    },
    retry: false
  });
  return {
    data,
    isLoading,
    isError,
    error
  };
};